// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14N4P","col":"styles_col__2k-oO"};